export const building = {
  // patch: 'building-details-updated',
  // post: 'new-building-created',
  // delete: 'building-deleted',
  excel: 'buildings-excel-file-created',
  details: 'group-of-building-details-received',
  'get-buildings-by-postcode': 'building-list-received'
}
